import { Button, Stack, TextField } from "@mui/material";
import { useAuth } from "../../providers/AuthenticationProvider";
import { useState } from "react";
import { useNetwork } from "../../providers/NetworkProvider";
import { useSnackbar } from "../../providers/SnackbarProvider";

const MakeTrader = () => {
	const [newTraderUid, setNewTraderUid] = useState<string>("");
	const { makePost } = useNetwork();
	const { openLoadingSnackbar, closeLoadingSnackbar, openSnackbar } =
		useSnackbar();
	const { user } = useAuth();
	const handleNewTraderUidChange = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		setNewTraderUid(event.target.value);
	};
	const handleMakeTrader = async () => {
		if (user == null) return;
		openLoadingSnackbar();
		try {
			const tokenId = await user.getIdToken();
			const res = await makePost(
				"admin/createTrader",
				{
					userUid: newTraderUid,
				},
				tokenId
			);
			console.log(res);
			if (res.status === 200) {
				openSnackbar(
					"Success",
					"The user has been made a trader",
					"success"
				);
			} else {
				throw new Error("something went wrong");
			}
		} catch (err) {
			const error = err as Error;

			openSnackbar("Error", error.message, "error");
			console.error(err);
		}
		closeLoadingSnackbar();
	};
	return (
		<>
			<Stack
				spacing={2}
				sx={{ maxWidth: 440, margin: "auto", display: "block" }}
			>
				<h3>Make trader</h3>
				<TextField
					id="uid"
					label="uid"
					color="primary"
					fullWidth
					value={newTraderUid}
					onChange={handleNewTraderUidChange}
				/>
				<Button
					variant="contained"
					color="secondary"
					onClick={handleMakeTrader}
					size="large"
					fullWidth
					sx={{
						height: "55px",
						textTransform: "none",
						fontFamily: "Work Sans !important",
					}}
				>
					Make Trader
				</Button>
			</Stack>
		</>
	);
};

export default MakeTrader;
